import { css } from '@microsoft/fast-element';
export const foundationBannerStyles = css `
  @keyframes delete-animate {
    from {
      height: 100px;
      opacity: 100%;
    }

    to {
      height: 0;
      opacity: 0%;
    }
  }

  @keyframes append-animate {
    from {
      height: 0;
      opacity: 0%;
    }

    to {
      height: var(--banner-height);
      opacity: 100%;
    }
  }

  :host {
    --banner-width: 100%;
    --banner-height: 65px;
    --flow: row;
  }

  @media screen and (max-width: 640px) {
    :host {
      --flow: column;
      --banner-height: 100px;
    }
  }

  .banner {
    animation: append-animate 0.3s linear;
    width: var(--banner-width);
    height: var(--banner-height);
    background-color: var(--fill-color);
    display: flex;
    flex-direction: var(--flow);
    padding: 5px 8px;
    box-sizing: border-box;
    overflow: hidden;
  }

  .banner-delete {
    animation: delete-animate 0.3s linear;
    opacity: 0%;
  }

  .content {
    display: flex;
    align-items: center;
    flex: 2;
    font-size: 12px;
    overflow: hidden;
  }

  .action {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    gap: 10px;
    flex: 1;
    overflow: hidden;
  }
`;
